import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, switchMap, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CartService } from '../services/cart.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private cartService: CartService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const isCheckout = state.url.includes('checkout');
    if (!isCheckout) return of(true);

    const navigationState =
      this.router.getCurrentNavigation()?.extras.state ||
      (typeof history !== 'undefined' ? history.state : {});
    if (navigationState?.sampleOrderConfirmation) return of(true);

    return this.authService.getUserState$().pipe(
      take(1),
      switchMap((user) => {
        return this.cartService.fetch(user).pipe(
          take(1),
          map((cart) => {
            console.log(cart,'cartttttt')
            if (cart?.totalItems) {
              return true;
            }
            return this.router.parseUrl('/my-cart'); // redirect
          }),
          catchError(() => of(this.router.parseUrl('/my-cart')))
        );
      })
    );
  }
}
